
















































































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";

import {mapGetters} from "vuex";
import {User} from "@/types";
import {AxiosError, AxiosResponse} from "axios";
import FollowBtn from "@/components/user/_followBtn.vue";
import {Swiper, SwiperSlide} from "vue-awesome-swiper";
import UserAvatar from "@/components/user/_userAvatar.vue";

@Component({
    computed: {...mapGetters(["user"])},
    components: {
        FollowBtn,
        Swiper,
        SwiperSlide,
        UserAvatar
    },
})
export default class UserHeader extends Vue {
    userInfo: any = [];
    postCnt: number = 0;
    user!: User;

    profileImg: string = '';
    TMSswiperOption = {
        slidesPerView: 'auto',
        spaceBetween: '0.4%',
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        breakpoints: {
            300: {
                slidesPerView: 3.5
            },
            480: {
                slidesPerView: 3.5
            },
            768: {
                slidesPerView: 5.5
            },
            992: {
                slidesPerView: 7
            },
            1200: {
                //slidesPerView: 7
            }
        }
    }
    followKey = Date.now()

    mounted() {
        this.$store.dispatch("loginState")
            .then(() => {
                this.fetch()

            })
            .finally(() => {

            })
    }


    fetch() {
        this.$api.channel(this.$route.params.channel_id)
            .then((res: any) => {
                const {target} = res.result
                this.userInfo = target;
                this.$store.commit("channelUserInfo", this.userInfo);
                if (res.userInfo) {
                    this.profileImg = this.userInfo.picture
                }
                else {
                    this.profileImg = 'img/300_300_default_profile.png'
                }
                this.followKey = Date.now();
            })
            .then(() => {
                this.postCntFetch(this.userInfo.id);
            })
            .catch((err: any) => {
            })
    }

    postCntFetch(userId: number) {
        this.$api.userPostCnt(userId)
            .then((res: number) => {
                this.postCnt = res;
            })
            .catch((err: AxiosError) => {

            })
    }

    followUser() {
        this.$api.follow(this.userInfo.id)
            .then((res: any) => {
                //todo: follow 버튼 새로고침 처리
                //todo: 백엔드 수정해야됨
                if (res.is_following) {
                    // console.log('following...')
                }

            })
            .catch((err: any) => {

            })

    }


    currPage(routeName: string) {

        let result = '';
        if ((routeName === this.$route.name) && Object.keys(this.$route.query).length === 0) {
            result = 'active'
        }
        else if (routeName === this.$route.name) {
            result = 'active'
        }

        return result;
    }

    reFetch() {
        this.fetch();
        this.$store.dispatch('reloadUserInfo')
    }

    movePage(page: string) {
        if (page === 'timeline') {
            this.$router.push(`/${this.$i18n.locale}/channel/${this.userInfo && this.userInfo.channel_id}/timeline`)
        }
        else if (page === 'following') {

            this.$router.push(`/${this.$i18n.locale}/channel/${this.userInfo && this.userInfo.id}/followings`)

        }
        else if (page === 'follower') {
            this.$router.push(`/${this.$i18n.locale}/channel/${this.userInfo && this.userInfo.id}/followers`)
        }
    }

    @Watch('$route.params.channel_id')
    watchParams() {
        this.fetch();
    }
}
